module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("出题")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', {
    staticClass: "rowheight"
  }, [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("guid")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid，可以是fh1之类"
    },
    model: {
      value: (_vm.pInfo.guid),
      callback: function($$v) {
        _vm.pInfo.guid = $$v
      },
      expression: "pInfo.guid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("main")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数学长征中题号"
    },
    model: {
      value: (_vm.pInfo.main),
      callback: function($$v) {
        _vm.pInfo.main = $$v
      },
      expression: "pInfo.main"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("problemImg")]), _vm._v(" "), _c('el-col', {
    staticClass: "xtextleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "问题图片,用辅助上传OSS中的工具上传"
    },
    model: {
      value: (_vm.pInfo.problemImg),
      callback: function($$v) {
        _vm.pInfo.problemImg = $$v
      },
      expression: "pInfo.problemImg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("answer")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案只能输入"
    },
    model: {
      value: (_vm.pInfo.answer),
      callback: function($$v) {
        _vm.pInfo.answer = $$v
      },
      expression: "pInfo.answer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("rank")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目难度级别"
    },
    model: {
      value: (_vm.pInfo.rank),
      callback: function($$v) {
        _vm.pInfo.rank = $$v
      },
      expression: "pInfo.rank"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60dcaf03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fhCreateProblem.vue
// module id = 646
// module chunks = 7